import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class ProjectDeliveryRequestActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/Accounting/DeliveryRequest/DeliveryRequestBrowser")
	}

	render() {
		return (
			<Activity 
				name="ProjectDeliveryRequest"
				RenderedComponent={this.RenderedComponent}
				context="ProjectDeliveryRequest"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(ProjectDeliveryRequestActivity)
